import { render, staticRenderFns } from "./JewelryCertificate.vue?vue&type=template&id=2a1279bf&scoped=true"
import script from "./JewelryCertificate.vue?vue&type=script&lang=js"
export * from "./JewelryCertificate.vue?vue&type=script&lang=js"
import style0 from "./JewelryCertificate.vue?vue&type=style&index=0&id=2a1279bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1279bf",
  null
  
)

export default component.exports